module.exports = __webpack_public_path__ + "static/media/spotify-button.fd06efef.svg";